import { render, staticRenderFns } from "./DdmStatisticsPage.vue?vue&type=template&id=054113de&"
import script from "./DdmStatisticsPage.vue?vue&type=script&lang=js&"
export * from "./DdmStatisticsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports